module.exports = __webpack_public_path__ + "static/media/mockup--dark.5d1afc2e.png";